import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  total: 0,
  form: {},
  dialog: false,
};

const referencesSlice = createSlice({
  name: "references",
  initialState,
  reducers: {
    setDialog: (state, { payload }) => {
      if (payload) {
        state.form = payload;
      } else state.form = initialState.form;
      state.dialog = !state.dialog;
    },
  },
});

export const { setDialog } = referencesSlice.actions;
export default referencesSlice.reducer;
